import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * Returns an new object without mutating it.
 * @param {Object} the current Object
 * @param {Object} the changes to the Object
 * @return {Object} a new object with changes assigned
 */
var update = function update(obj, mutations) {
  return _objectSpread(_objectSpread({}, obj), mutations);
};
/*
 * Returns an new object without mutating it.
 * @param {Array} the list of Objects
 * @param {Number} the index you want to update.
 * @param {Object} the changes to the Object
 * @return {Array} a new list with the with changes assigned
 */


var updateArray = function updateArray(list, index, mutations) {
  return [].concat(_toConsumableArray(list.slice(0, index)), [update(list[index], mutations)], _toConsumableArray(list.slice(index + 1)));
};

export default updateArray;